var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { enqueueSnackbar } from "notistack";
import { getErrorMessage } from "../../../utilities/axios-utility";
import { errorSnackbar } from "../../../shared/snackbar-constants";
import GooglePayButton from "@google-pay/button-react";
import * as yup from "yup";
import { useFormik } from "formik";
import { useTranslation } from "react-i18next";
import { Grid, Autocomplete, TextField } from "@mui/material";
import { ApTextFieldGridItem } from "../../../shared/components/forms/ApTextFieldGridItem";
import { FormConstants } from "../../../shared/components/forms/Constants";
export var GooglePayPage = function (_a) {
    var paymentSessionId = _a.paymentSessionId, mid = _a.mid, geoData = _a.geoData, setPaymentResult = _a.setPaymentResult, setPaymentResultOpened = _a.setPaymentResultOpened, setPaymentInProgress = _a.setPaymentInProgress, api = _a.api, currency = _a.currency, totalAmount = _a.totalAmount, nuveiGooglePaySettings = _a.nuveiGooglePaySettings;
    var processorCommonCode = "NVGPAY";
    var settings = nuveiGooglePaySettings.GoogleSettings;
    var _b = useTranslation(), t = _b.t, i18n = _b.i18n;
    var countries = geoData.countries;
    var _c = useState(null), sessionTokenData = _c[0], setSessionTokenData = _c[1];
    var initSessionToken = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.GetSessionToken(paymentSessionId, mid)];
                case 1:
                    response = _a.sent();
                    setSessionTokenData(response.data);
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        initSessionToken();
    }, []);
    var _d = useState({
        apiVersion: 2,
        apiVersionMinor: 0,
        allowedPaymentMethods: [
            {
                type: "CARD",
                parameters: {
                    allowedAuthMethods: settings.allowedAuthMethods,
                    allowedCardNetworks: settings.allowedCardNetworks,
                },
                tokenizationSpecification: {
                    type: "PAYMENT_GATEWAY",
                    parameters: {
                        gateway: settings.gateway,
                        gatewayMerchantId: settings.gatewayMerchantId,
                    },
                },
            },
        ],
        transactionInfo: {
            countryCode: "US",
            currencyCode: currency,
            totalPriceStatus: "FINAL",
            totalPrice: String(totalAmount),
            totalPriceLabel: "Total",
        },
        merchantInfo: {
            merchantId: settings.merchantId,
            merchantName: settings.merchantName,
        },
    }), paymentRequest = _d[0], setPaymentRequest = _d[1];
    var emptyConfig = {
        email: "",
        country: "",
    };
    var ValidationScheme = yup.object({
        email: yup.string().email(t("email must be a valid email")).required(t(FormConstants.FieldIsRequired)),
        country: yup
            .string()
            .typeError(t(FormConstants.FieldIsRequired))
            .required(t(FormConstants.FieldIsRequired))
            .nullable(),
    });
    var formik = useFormik({
        initialValues: emptyConfig,
        validationSchema: ValidationScheme,
        enableReinitialize: true,
        onSubmit: function (values) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                paymentRequest.transactionInfo.countryCode = values.country;
                setPaymentRequest(__assign({}, paymentRequest));
                return [2 /*return*/];
            });
        }); },
    });
    var handleGooglePayClick = function (event) {
        if (!formik.values.country) {
            event.preventDefault();
        }
        formik.handleSubmit();
    };
    var submitPaymentInfo = function (email, country) { return __awaiter(void 0, void 0, void 0, function () {
        var paymentInfo;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    paymentInfo = {
                        paymentSessionId: paymentSessionId,
                        merchantProcessorId: String(mid),
                        clientEmail: email,
                        country: country,
                    };
                    return [4 /*yield*/, api.SubmitAPMPaymentUpdate(paymentInfo)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var checkPaymentStatus = function () { return __awaiter(void 0, void 0, void 0, function () {
        var result, code, data, description, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, api.CheckPaymentStatus(paymentSessionId)];
                case 1:
                    result = _a.sent();
                    code = result.code, data = result.data, description = result.description;
                    if (code === 200000) {
                        if (data.detail.state === "CREATED" || data.detail.state === "PAYER_ACTION_REQUESTED") {
                            checkPaymentStatus();
                        }
                        else {
                            setPaymentResult(data);
                            setPaymentInProgress(false);
                        }
                    }
                    else {
                        enqueueSnackbar(description, errorSnackbar);
                        setPaymentInProgress(false);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    enqueueSnackbar(getErrorMessage(error_1), errorSnackbar);
                    setPaymentInProgress(false);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var processPayment = function (paymentMethodData) {
        if (!window.SafeCharge || !sessionTokenData)
            return;
        setPaymentInProgress(true);
        setPaymentResultOpened(true);
        var nuveiSettings = nuveiGooglePaySettings.NuveiSDKSettings;
        var sfc = window.SafeCharge({
            sessionToken: sessionTokenData.sessionToken,
            merchantId: nuveiSettings.merchantId,
            merchantSiteId: nuveiSettings.merchantSiteId,
            env: nuveiSettings.environment,
        });
        var email = formik.values.email;
        var country = formik.values.country;
        sfc.createPayment({
            sessionToken: sessionTokenData.sessionToken,
            clientUniqueId: sessionTokenData.paymentId,
            merchantId: nuveiSettings.merchantId,
            merchantSiteId: nuveiSettings.merchantSiteId,
            env: nuveiSettings.environment,
            countryCode: formik.values.country,
            currencyCode: currency,
            billingAddress: {
                email: email,
                country: country,
            },
            // googlePay3Dflow: "enable",
            paymentOption: {
                card: {
                    externalToken: {
                        externalTokenProvider: "GooglePay",
                        mobileToken: JSON.stringify(paymentMethodData),
                    },
                },
            },
        }, function (res) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (nuveiSettings.environment === "int") {
                            console.log("Google pay result:", res);
                        }
                        if (!(res.cancelled === true)) return [3 /*break*/, 1];
                        setPaymentResultOpened(false);
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, submitPaymentInfo(email, country)];
                    case 2:
                        _a.sent();
                        checkPaymentStatus();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); });
    };
    return (_jsxs(_Fragment, { children: [_jsxs(Grid, __assign({ container: true, spacing: 2 }, { children: [_jsx(ApTextFieldGridItem, { name: "email", label: t("Email"), required: true, formik: formik, xs: 6, foolWidth: true, size: "small", sx: { minWidth: 300, padding: 2 } }), _jsx(Grid, __assign({ item: true, xs: 6, sx: { minWidth: 300, padding: 2 } }, { children: _jsx(Autocomplete, { disablePortal: true, options: countries, size: "small", renderInput: function (params) { return (_jsx(TextField, __assign({}, params, { required: true, error: formik.touched["country"] && Boolean(formik.errors["country"]), helperText: formik.touched["country"] && formik.errors["country"], label: t("Country"), InputProps: __assign(__assign({}, params.InputProps), { endAdornment: _jsx(React.Fragment, { children: params.InputProps.endAdornment }) }) }))); }, onChange: function (e, selectedItem) {
                                formik.setFieldValue("country", selectedItem ? selectedItem.alpha2 : []);
                            }, getOptionLabel: function (option) { return "".concat(option.name); } }) }))] })), _jsx("div", { children: _jsx(GooglePayButton, { buttonType: "pay", buttonColor: "default", buttonSizeMode: "fill", environment: settings.environment, paymentRequest: paymentRequest, onLoadPaymentData: function (paymentRequest) {
                        processPayment(paymentRequest.paymentMethodData);
                    }, onClick: handleGooglePayClick, style: { width: "100%", height: 50 } }) })] }));
};
